import React, { useState, useEffect, forwardRef } from "react";
import { 
  Layout, Row, Col, Button, Input, Modal, Table, Space, Form, Select, 
  notification, Menu, Tag, Pagination, Popconfirm, Empty, 
} from "antd";
import { SiteHeader } from "../components";
import { PageFooter } from './footer';
import { useSelector } from "react-redux";
import { RootStoreModel } from "@redux/reducers";
import { MSALObjLogin } from "../auth/authInstance";
import { useHistory } from 'react-router'
import { PlusOutlined } from "@ant-design/icons";
import { getDocList } from "@axios/api.content";
import { 
  getTenantList, addTenant, deleteTenant, getTenantScopes, 
  addTenantScopes, getTenantTags, getTenantScopesAccount, 
  deleteTenantScopesAccount
} from "../axios/api.account"
import Store from "@redux/store";
import { FetchingAccount, UpdateRegisShow } from "@redux/actions";
import { gaEvent } from "../withTracker"
import { createAccount } from "@axios/api.account";
import "./pages.scss";

import { useTranslation } from "react-i18next";

const { Column } = Table;
const { Item } = Form;
function TenantPage() {
  const user = useSelector((state: RootStoreModel) => state.userState);
  const [isShowAddForm, setIsShowAddForm] = useState<boolean>(false);
  const [isShowAddScopeForm, setIsShowAddScopeForm] = useState<boolean>(false);
  const [isShowTenantForm, setIsShowTenantForm] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [scopeData, setScopeData] = useState<any[]>([]);
  const [tenantData, setTenantData] = useState<any[]>([]);
  const [search, setSearch] = useState<string>("");
  const [scopeType, setScopeType] = useState<string>("All");
  const [current, setCurrent] = useState<string>("accout");
  const [formRef] = Form.useForm();
  const [formScopeRef] = Form.useForm();
  const [formAccountRef] = Form.useForm();

  const [selectRow, setSelectRow] = useState<any>({});
  const [tagList, setTagList] = useState<any[]>([]);
  const [inputTags, setInputTags] = useState<string[]>([]);
  const [inputTagValue, setInputTagValue] = useState<string>("");
  const [selectTag, setSelectTag] = useState<any[]>([]);
  const [selectTenant, setSelectTenant] = useState<any[]>([]);
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [pageScopeIndex, setPageScopeIndex] = useState<number>(1);
  const [pageScopeSize, setPageScopeSize] = useState<number>(10);
  const [totalScopeCount, setTotalScopeCount] = useState<number>(0);
  const [pageTenantIndex, setPageTenantIndex] = useState<number>(1);
  const [pageTenantSize, setPageTenantSize] = useState<number>(10);
  const [totalTenantCount, setTotalTenantCount] = useState<number>(0);
  const [copilotOpen, setCopilotOpen] = useState(false);

  const account = useSelector(
    (store: RootStoreModel) => store.userState.account
  );
  const [accountName, setAccountName] = useState<string>("");

  const { t } = useTranslation();
  
  const getList = (pindex = pageIndex,
    psize = pageSize) => {

    getTenantList({ search: search, pageIndex: pindex, pageSize: psize }).then(c => {
      setPageIndex(c.pageIndex);
      setPageSize(c.pageSize)
      setData(c.dataList)
      setTotalCount(c.totalCount)
    })
  }
  const getScopeList = (pindex = pageIndex,
    psize = pageSize) => {

    getTenantScopes({ search: search, pageIndex: pindex, pageSize: psize }).then(c => {
      setPageScopeIndex(c.pageIndex);
      setPageScopeSize(c.pageSize)
      setScopeData(c.dataList)
      setTotalScopeCount(c.totalCount)
    })
  }
  const getTenantScopeList = (accountName: string, pindex=pageIndex, psize=pageSize) => {
    setAccountName(accountName);
    getTenantScopesAccount(accountName, {search: search, pageIndex: pindex, pageSize: psize}).then(
      (res) => {
        let data = res.dataList.filter((item: any) => item.name);
        setTenantData(data);
        setPageTenantIndex(res.pageIndex);
        setPageTenantSize(res.pageSize);
        setTotalTenantCount(res.totalCount);
      }
    )
  }
  const handleCancelTenent = () => {
    setIsShowTenantForm(false);
    setAccountName("")
    setSearch("")
  }

  useEffect(() => {
    getTagListOn();
  }, [])
  const onSearch = (res: any) => {
    if (current == "tenantAuth") {
      accountName ? getTenantScopeList(accountName, 1) : getScopeList(1);
    } else {
      getList(1);
    }
  }
  const editClick = (row: any) => {
    formRef.setFieldsValue(row)
    setSelectRow(row)
    if (row.tags) {
      var tags = row.tags.split(";")
      setInputTags(tags);
    } else {
      setInputTags([]);
    }
    setInputTagValue("");

    setIsShowAddForm(true)

  }
  const deleteClick = (row: any) => {
    deleteTenant(row.id).then(c => {
      notification.success({ message: t("删除成功") })
      getList(1)
    })
  }
  const deleteTenantAuth = (accountName: string) => {
    deleteTenantScopesAccount(accountName).then(c => {
      if (c) {
        notification.success({ message: t("删除成功") })
        getScopeList(1)
      }    
    })
  }
  const addTenantClick = () => {
    setLoading(true);
    formRef?.validateFields().then((res) => {
      if (selectRow.id) {
        res.id = selectRow.id;
        var tags = "";
        inputTags.forEach((tag: string, index: number) => {
          tags = tags + tag;
          if (index != inputTags.length - 1) {
            tags += ";";
          }
        });
        res.tags = tags;
        addTenant(res).then(c => {
          notification.success({ message: t("更新成功") })
          if (user.account.tenantId == res.id) {
            Store.dispatch(FetchingAccount());
          }
          getList(1);
          setLoading(false);
          setIsShowAddForm(false)
          formRef.resetFields()
        }, (() => {
          setLoading(false);
        }))
      } else {
        var tags = "";
        inputTags.forEach((tag: string, index: number) => {
          tags = tags + tag;
          if (index != inputTags.length - 1) {
            tags += ";";
          }
        });
        res.tags = tags;
        console.log("addTenant", res)
        addTenant(res).then(c => {
          notification.success({ message: t("添加成功") })
          getList(1);
          setLoading(false);
          setIsShowAddForm(false)
          formRef.resetFields()
        }, (() => {
          setLoading(false);
        }))
      }

    }, () => {

    })
  }
  const addTenantScopeClick = () => {
    formScopeRef?.validateFields().then((res) => {
      if (scopeType == "Tag") {
        var tags = "";
        selectTag.forEach((tag: string, index: number) => {
          tags = tags + tag;
          if (index != inputTags.length - 1) {
            tags += ";";
          }
        });
        res.tags = tags;
      } else if (scopeType == "Tenant") {
        res.tenantIds = selectTenant;
      }
      res["role"] = "Reader";
      addTenantScopes(res).then(c => {

        notification.success({ message: t("添加成功") })
        getScopeList(1);
        setLoading(false);
        setIsShowAddScopeForm(false)
        setScopeType("All")
        formScopeRef?.resetFields();
      }, () => {

      })

    }, () => {

    })
  }
  const handleMenuClick = (e: any) => {
    setCurrent(e.key)
    if (e.key == "tenantAuth") {
      getScopeList(1);
    } else if (e.key == "tenant") {
      getList(1);
    }
    setSearch("");
  }
  const scopeTypeChange = (e: any) => {
    setScopeType(e)
    setSelectTag([]);
    setSelectTenant([]);
  }
  const getTagListOn = () => {
    getTenantTags().then((res: any) => {
      setTagList(res)
    });
  }
  const inputTagsClose = (index: number) => {

    var arr: any[] = [];
    Object.assign(arr, inputTags)
    console.log("inputTagsClose1", arr)

    arr.splice(index, 1);
    console.log("inputTagsClose2", arr)
    var arr2: string[] = [];
    arr.forEach(element => {
      arr2.push(element)
    });
    setInputTags(arr2);
  }

  const handleInputConfirm = () => {
    console.log("handleInputConfirm", inputTagValue)
    if (inputTagValue) {

      var arr: any[] = [];
      Object.assign(arr, inputTags)
      arr.push(inputTagValue);
      setInputTags(arr)
      setInputTagValue("");
    }
  }
  const handleInputChange = (e: any) => {
    setInputTagValue(e.target.value);
  };
  const saveAccountIClick = () => {
    formAccountRef?.validateFields().then((res) => {
      //const { version, name, email, phoneNumber, company } = res;
      createAccount(res).then(
        () => {
          notification.success({ message: t("修改成功") });
          Store.dispatch(FetchingAccount());
          Store.dispatch(UpdateRegisShow(false));
        },
        () => {

        }
      );
    })
  }
  return (
    (<Layout className="homeLayout">
      <SiteHeader
        copilotOpen={copilotOpen} 
        setCopilotOpen={setCopilotOpen} 
      ></SiteHeader>
      <div style={{ padding: "36px 36px 36px 72px", marginTop: 53 }}>
        <Row>
          <Col span={4}>
            <Menu mode="inline" defaultSelectedKeys={['accout']} defaultOpenKeys={['accout']} onClick={handleMenuClick}>
              <Menu.Item key="accout" >
                {t("账号信息")}
              </Menu.Item>
              <Menu.Item key="tenant" >
                {t("租户管理")}
              </Menu.Item>
              {/* <Menu.Item key="tenantAuth" >
                {t("租户授权")}
              </Menu.Item> */}
            </Menu>
          </Col>
          <Col span={20} style={{ padding: 16 }}>
            <div hidden={current != "tenant"}>
              <Row>
                <Col span={3}>
                  <Button ghost type="primary" style={{ width: "100%" }}
                    onClick={() => { setIsShowAddForm(true); setInputTagValue(""); setInputTags([]); setSelectRow({}); gaEvent("tenantPage", "onClick", "添加新租户") }}>
                    <PlusOutlined />{t("添加新租户")}</Button>
                </Col>
                <Col span={1}></Col>
                <Col span={3}> <Input.Search placeholder={t("搜索租户名称")} value={search} onChange={(e) => setSearch(e.target.value)} onSearch={onSearch} style={{ width: "100%", height: "50px", fontSize: 16, color: '#1890ff', }} /></Col>
              </Row>
              <Row>
                <Table 
                  pagination={false} 
                  size="middle" 
                  dataSource={data} 
                  rowKey={item => item.id}
                  style={{ width: "100%" }}
                  locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                >
                  {/* <Column
                        title="序号"
                        key="inx"
                        dataIndex="inx"
                        render={(v, row, index) => {
                          return index+1}}
                    ></Column> */}
                  <Column
                    title={t("租户名称")}
                    key="name"
                    dataIndex="name"
                  ></Column>
                  <Column
                    title={t("标签")}
                    key="tags"
                    dataIndex="tags"
                  ></Column>
                  <Column
                    title={t("状态")}
                    key="status"
                    dataIndex="status"
                  ></Column>

                  <Column
                    title={t("操作")}
                    key="id"
                    dataIndex="id"
                    render={(v, row: any, index) => {
                      return (
                        <Space>
                          <Button disabled={row?.isOwner} type="link" onClick={() => { editClick(row); gaEvent("tenantPage", "onClick", "editClick") }}>{t("编辑")}</Button>
                          <Button disabled={row?.isOwner} type="link" onClick={() => { deleteClick(row); gaEvent("tenantPage", "onClick", "deleteClick") }}>{t("删除")}</Button>
                        </Space>
                      )
                    }}
                  ></Column>
                </Table>
                <Pagination
                  style={{ textAlign: "right", marginTop: "20px" }}
                  pageSize={pageSize}
                  current={pageIndex}
                  total={totalCount}
                  showTotal={(total, range) =>
                    `${range[0]}-${range[1]} / ${total} ${t("条")}`
                  }
                  onChange={(page, pageSize) => {
                    getList(page, pageSize);
                  }}
                  onShowSizeChange={(current, size) => getList(current, size)}
                ></Pagination>
              </Row>
            </div>
            <div hidden={current != "tenantAuth"}>
              <Row>
                <Col span={3}>
                  <Button ghost type="primary" style={{ width: "100%" }}
                    onClick={() => { setIsShowAddScopeForm(true); setSelectRow({}); gaEvent("tenantPage", "onClick", "添加授权") }}><PlusOutlined />{t("添加授权")}</Button>
                </Col>
                <Col span={1}></Col>
                <Col span={3}> <Input.Search placeholder={t("搜索账号")} value={search} onChange={(e) => setSearch(e.target.value)} onSearch={onSearch} style={{ width: "100%", height: "50px", fontSize: 16, color: '#1890ff', }} /></Col>
              </Row>
              <Row>
                <Table 
                  pagination={false} 
                  size="middle" 
                  dataSource={scopeData} 
                  rowKey={item => item.accountName}
                  style={{ width: "100%" }}
                  locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                >
                  {/* <Column
                        title="序号"
                        key="inx"
                        dataIndex="inx"
                        render={(v, row, index) => {
                          return index+1}}
                    ></Column> */}
                  <Column
                    title={t("账号类型")}
                    key="accountType"
                    dataIndex="accountType"
                  ></Column>
                  <Column
                    title={t("账号")}
                    key="accountName"
                    dataIndex="accountName"
                  ></Column>
                  <Column
                    title={t("授权层级")}
                    key="scopeType"
                    dataIndex="scopeType"
                    render={(v, row: any) => {
                      return (
                        <p>{v == "Tag" ? v + "--" + row.tags : v}</p>
                      )
                    }}
                  ></Column>
                  <Column
                    title={t("授权租户")}
                    key="tenantCount"
                    dataIndex="tenantCount"
                    render={(v, row: any, i) => {
                      return (
                        <Button 
                          disabled={!row.tenantCount} 
                          type="link" 
                          onClick={() => {
                            setIsShowTenantForm(true)
                            getTenantScopeList(row.accountName)
                            gaEvent("tenantPage", "onClick", "查看授权租户")
                          }}
                        >{ v }</Button>
                      )
                    }}
                  ></Column>
                  <Column
                    title={t("操作")}
                    key="id"
                    dataIndex="id"
                    render={(v, row: any, index) => {
                      return (
                        <Popconfirm
                            title={`${t("确认删除")}？`}
                            onConfirm={() => {
                              deleteTenantAuth(row.accountName); 
                              gaEvent("tenantPage", "onClick", "deleteTenantAuth"); 
                            }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                          <Button disabled={!row.scopeType && !row.tenantCount} type="link" ghost>{t("删除")}</Button>
                        </Popconfirm>
                      )
                    }}
                  ></Column>
                </Table>
                <Pagination
                  style={{ textAlign: "right", marginTop: "20px" }}
                  pageSize={pageScopeSize}
                  current={pageScopeIndex}
                  total={totalScopeCount}
                  showTotal={(total, range) =>
                    `${range[0]}-${range[1]} / ${total} ${t("条")}`
                  }
                  onChange={(page, pageSize) => {
                    getScopeList(page, pageSize);
                  }}
                  onShowSizeChange={(current, size) => getScopeList(current, size)}
                ></Pagination>
              </Row>
            </div>
            <div hidden={current != "accout"}>
              <Form
                labelCol={{ span: 6 }}
                form={formAccountRef}
                layout="vertical"
                initialValues={account}
                onFinishFailed={() => { }}
              >
                <Item name="account" style={{display:"none"}}></Item>
                <Item label={t("版本")} name="version" rules={[{ required: true }]}>
                  <Select disabled>
                    <Select.Option value="Basic">{t("基础版")}</Select.Option>
                    <Select.Option value="Standard">{t("标准版")}</Select.Option>
                    <Select.Option value="Advanced">{t("高级版")}</Select.Option>
                    <Select.Option value="Customized">{t("定制版")}</Select.Option>
                    <Select.Option value="Leased">{t("租赁版")}</Select.Option>
                  </Select>
                </Item>

                <Item label={t("设备数量")}>
                  <Input type="text" disabled value={account?.maxDeviceCount <= 0 ? "不限制": account?.maxDeviceCount } />
                </Item>

                <Item label={t("到期日期")}>
                  <Input type="text" disabled value={account?.expireDate ?? "不限制"}/>
                </Item>
                
                <Item label={t("邮箱")} name="email" rules={[{ required: true }]}>
                  <Input type="email" disabled />
                </Item>

                <Item label={t("姓名")} name="name" rules={[{ required: true }]}>
                  <Input />
                </Item>

                <Item
                  label={t("手机号码")}

                  name="phoneNumber"
                  rules={[{ required: true }]}
                >
                  <Input type="tel" />
                </Item>

                <Item
                  label={t("公司名称")}
                  name="company"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Item>
              </Form>

              <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                <Button style={{ width: 100 }} type="primary" onClick={() => { saveAccountIClick(); gaEvent("tenantPage", "onClick", "saveAccountIClick") }}> {t("保存")} </Button>
              </div>
            </div>
          </Col>
        </Row>


        <Modal
          confirmLoading={loading}
          maskClosable={false}
          open={isShowAddForm}
          destroyOnClose={true}
          title={t("添加租户")}
          forceRender={true}
          width={"650px"}
          onOk={() => addTenantClick()}
          onCancel={() => {
            setIsShowAddForm(false)

          }}
          okText={t("确认")}
          cancelText={t("取消")}
        >
          <Form
            labelCol={{ span: 6 }}
            form={formRef}
            layout="vertical"
            initialValues={{ status: "Active" }}
          >
            <Item label={t("租户名称")} name="name" rules={[{ required: true }]}>
              <Input></Input>
            </Item>
            <Item label={t("租户标签")} name="inputTagValue" >
              <Row>
                {inputTags.map((value: any, index: number) => (
                  <Tag key={index + value} closable={true} className="edit-tag" onClose={() => { inputTagsClose(index) }} >{value}
                  </Tag>
                ))}
                <Input
                  type="text"
                  size="small"
                  className="tag-input"
                  value={inputTagValue}
                  placeholder={t("Enter键添加tag")}
                  onChange={handleInputChange}
                  onPressEnter={handleInputConfirm}
                />
              </Row>

            </Item>
            <Item label={t("状态")} name="status" rules={[{ required: true }]}>
              <Select>
                <Select.Option value="Active">Active</Select.Option>
                <Select.Option value="Disabled">Disabled</Select.Option>
              </Select>
            </Item>
          </Form>

        </Modal>
        <Modal
          confirmLoading={loading}
          maskClosable={false}
          open={isShowAddScopeForm}
          destroyOnClose={true}
          title={t("租户授权")}
          forceRender={true}
          width={"650px"}
          onOk={() => addTenantScopeClick()}
          onCancel={() => {
            setIsShowAddScopeForm(false)
          }}
          okText={t("确认")}
          cancelText={t("取消")}
        >
          <Form
            labelCol={{ span: 6 }}
            form={formScopeRef}
            layout="vertical"
            initialValues={{ accountType: "AAD", status: "Active", scopeType: "All" }}
          >
            <Item label={t("账号类型")} name="accountType" rules={[{ required: true }]}>
              <Select>
                <Select.Option value="AAD">AAD</Select.Option>
                <Select.Option value="Email">Email</Select.Option>
              </Select>
            </Item>
            <Item label={t("登录账号")} name="account" rules={[{ required: true }]}>
              <Input></Input>
            </Item>
            {/* <Item label={t("角色")} name="role" rules={[{ required: true }]}>
              <Select>
                <Select.Option value="CoAdmin">CoAdmin</Select.Option>
                <Select.Option value="Reader">Reader</Select.Option>
                <Select.Option value="Contributor">Contributor</Select.Option>
              </Select>
            </Item> */}
            <Item label={t("状态")} name="status" rules={[{ required: true }]}>
              <Select>
                <Select.Option value="Active">Active</Select.Option>
                <Select.Option value="Disabled">Disabled</Select.Option>
              </Select>
            </Item>
            <Item label={t("授权范围")} name="scopeType" rules={[{ required: true }]}>
              <Select onChange={scopeTypeChange}>
                <Select.Option value="All">{t("全部")}</Select.Option>
                <Select.Option value="Tenant">{t("租户")}</Select.Option>
                <Select.Option value="Tag">{t("设备组")}</Select.Option>
              </Select>
            </Item>
            <Item >
              {scopeType == "Tag" && (
                <Select

                  mode="multiple"
                  style={{ width: '100%' }}
                  placeholder={t("请选择设备组")}
                  onChange={(e: any) => { setSelectTag(e) }}
                >
                  {
                    Array.isArray(tagList) ?
                      tagList.map(item => (
                        <Select.Option key={item.id} value={item.name} label={item.name}>{item.name}</Select.Option >
                      )) : ""
                  }
                </Select>
              )}
              {scopeType == "Tenant" && (
                <Select
                  mode="multiple"
                  style={{ width: '100%' }}
                  placeholder={t("请选择租户")}
                  onChange={(e: any) => { setSelectTenant(e) }}
                >
                  {
                    Array.isArray(data) ?
                      data.map(item => (
                        <Select.Option key={item.id} value={item.id} label={item.name}>{item.name}</Select.Option >
                      )) : ""
                  }
                </Select>
              )}
            </Item>
          </Form>

        </Modal>
        <Modal
          confirmLoading={loading}
          closable={true}
          open={isShowTenantForm}
          destroyOnClose={true}
          title={t("当前授权租户")}
          forceRender={true}
          width={"650px"}
          onCancel={() => handleCancelTenent()}
          footer={[
            <Button onClick={() => handleCancelTenent()}>{t("关闭")}</Button>
          ]}
        >
          <Row>
            <Col> 
              <Input.Search 
                placeholder={t("搜索租户名称")} 
                value={search} 
                onChange={(e) => setSearch(e.target.value)} 
                onSearch={onSearch} 
                style={{ width: "100%", height: "50px", fontSize: 16, color: '#1890ff', }} 
              />
            </Col>
          </Row>
          <Table 
            dataSource={tenantData} 
            pagination={false} 
            size="small"
            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
          >
            <Column title={t("租户名称")} dataIndex="name"></Column>
          </Table>
          <Pagination
            style={{ textAlign: "right", marginTop: "20px" }}
            pageSize={pageTenantSize}
            current={pageTenantIndex}
            total={totalTenantCount}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} / ${total} ${t("条")}`
            }
            onChange={(page, pageSize) => {
              getTenantScopeList(accountName, page, pageSize);
            }}
            onShowSizeChange={(current, size) => getTenantScopeList(accountName, current, size)}
          ></Pagination>
        </Modal>

      </div>
    </Layout>)
  );
}

export default TenantPage;
